module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-layout"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator": "/"
    }
  }, [_vm._l((_vm.Config.Breadcrumbs), function(breadcrumb) {
    return [(breadcrumb.to) ? _c('el-breadcrumb-item', {
      key: breadcrumb.name,
      attrs: {
        "to": breadcrumb.to
      }
    }, [_vm._v(_vm._s(breadcrumb.name))]) : _c('el-breadcrumb-item', {
      key: breadcrumb.name
    }, [_vm._v(_vm._s(breadcrumb.name))])]
  })], 2), _vm._v(" "), _c('v-card', [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-203b5b7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Inventory/DetailLayout.vue
// module id = 703
// module chunks = 0